// const baseurl = "https://hr-api-test.xyjhr.cn" //测试
const baseurl = "https://hr-api.xyjhr.cn" //正式 
// const baseurl = "http://localhost:28086" //本地
// const baseurl = 'http://192.168.31.29:28086'; //雅楠本地
export default baseurl;


// WEBPACK FOOTER //
// ./src/assets/js/baseurl.js